import { useEffect, useState } from "react";
import AudioPlayer from "../Main/AudioPlayer";
import audiobook1 from "../../Assets/Images/audiobook1.png";
import { GrNext, GrPrevious } from "react-icons/gr";
import { getBookProgress, getBookReadChapter, getReadBook } from "../../Services/BooksServices";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const AudioBooksChapters = ({ checkSubs, bookschap }) => {

    console.log("bookschap", bookschap)
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isRead, setIsRead] = useState(null);

    // Current chapter ka data
    const currentChapter = bookschap[currentIndex];

    // Next Chapter
    const nextChapter = () => {
        if (currentIndex < bookschap.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    // Previous Chapter
    const prevChapter = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const handleReadChapters = async () => {
        // setIsLoading(true)
        let response = await getReadBook(currentChapter?.book_id, currentChapter?.id)
        if (response.statusCode === 200) {
            // return console.log("response=>", response?.response?.data)
            // setBookschap(response?.response?.data)
            // setIsLoading(false)
        } else if (response.statusCode === 401) {
            // toast?.error(response?.errors)
            // setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                // toast?.error(value)
            }
            // setIsLoading(false)
        }
        // setIsLoading(false)
    }
    const handleBookProgess = async () => {
        // setIsLoading(true)
        let response = await getBookProgress(currentChapter?.book_id)
        console.log("respone", response)
        if (response.statusCode === 200) {
            // return console.log("response=>", response?.response?.data)
            // setBookschap(response?.response?.data)
            // setIsLoading(false)
        } else if (response.statusCode === 401) {
            // toast?.error(response?.errors)
            // setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
                // toast?.error(value)
            // }
            // setIsLoading(false)
        }
        // setIsLoading(false)
    }

    const handleBooksReadChapters = async () => {
        // setIsLoading(true)
        let response = await getBookReadChapter(currentChapter?.book_id, currentChapter?.id)
        setIsRead(response?.read)
        if (response.statusCode === 200) {
            // return console.log("response=>", response?.response?.data)
            // setBookschap(response?.response?.data)
            // setIsLoading(false)
        } else if (response.statusCode === 401) {
            // toast?.error(response?.errors)
            // setIsLoading(false)
        } else {
            // for (const [key, value] of Object.entries(response?.errors)) {
            //     // toast?.error(value)
            // }
            // setIsLoading(false)
        }
        // setIsLoading(false)
    }

    useEffect(() => { handleBooksReadChapters() }, [currentChapter?.book_id, currentChapter?.id])
    useEffect(() => { handleBookProgess() }, [currentChapter?.book_id])



    return (

        <>


            <div className="container px-5 my-5 book-detail">
                <div className="row align-items-center justify-content-around">

                    <div className="col-lg-auto" >
                        <div
                            style={{ backgroundImage: `url(${currentChapter?.image_file})` }}
                            className="background-image-blur audio-book-background card position-relative p-4 book-detail-card d-flex justify-content-center border-0 align-items-center"
                        >
                            <div className="foreground-content">
                                <AudioPlayer isRead={isRead} currentChapter={currentChapter} handleReadChapters={handleReadChapters} />
                            </div>
                        </div>



                    </div>

                    <div className="col-lg-6">
                        <h2 className="s-30 fw-600 mb-3">
                            {currentChapter?.heading || "No Chapter"}
                        </h2>
                        <p className="fw-300">{currentChapter?.content || "No Content"}</p>

                        {/* {currentChapter?.audio_file && (
                            <audio style={{ width: "100%" }} controls>
                                <source src={currentChapter.audio_file} type="audio/mpeg" />
                            </audio>
                        )} */}

                        <hr />

                        {/* Navigation Buttons */}

                        {
                            checkSubs === null ? (
                                <>
                                    <Button as={Link} to={"/subscription"} className="btn-danger w-100">Subscribe </Button>
                                </>
                            ) :

                                (
                                    <>
                                        <div className="d-flex justify-content-between">
                                            <button
                                                className="btn btn-danger rounded-circle d-flex justify-content-center align-items-center"
                                                style={{ width: "50px", height: "50px" }}
                                                onClick={prevChapter}
                                                disabled={currentIndex === 0}
                                            >
                                                <GrPrevious size={22} />

                                            </button>
                                            <button
                                                className="btn btn-danger rounded-circle d-flex justify-content-center align-items-center"
                                                style={{ width: "50px", height: "50px" }}
                                                onClick={nextChapter}
                                                disabled={currentIndex === bookschap.length - 1}
                                            >
                                                <GrNext size={22} />

                                            </button>
                                        </div>
                                    </>
                                )
                        }

                    </div>
                </div>
            </div>

        </>
    );
};

export default AudioBooksChapters;
